import React from 'react';
import { Icon, Input } from 'semantic-ui-react'
import TimeKeeper from 'react-timekeeper';
import './style.css';

class TimePicker extends React.Component {

  state = {
    visible: false
  };


  // receive time changing
  onChangeTimeHandler = (newTime) => {
    this.timeConverterAndCaller(newTime.formatted24);
  };

  // receive time done
  timeDoneHandler = (TimeOutput, Event) => {
    this.timeConverterAndCaller(TimeOutput.formatted24);
    if(this.props.unic === "S") {
      this.props.visi("SV");
    } else {
      this.props.visi("EV");
    }
  };

  // convert time into correct format set to method come from parent
  timeConverterAndCaller = (time) => {
    let timeString = time;
    let split = timeString.split(":");
    let splitElement = split[0];
    let length = splitElement.length;
    if(length == 1) {
      timeString = "0" + split[0] + ":" + split[1];
    }
    this.props.change(null, timeString);
  };

  visiHandler = () => {
    if(this.props.unic === "S") {
      this.props.visi("S");
    } else {
      this.props.visi("E");
    }
  };

  render() {

    let time = this.props.time;
    if(time!==null && time!=="" && time!==undefined) {
      let split = time.split(":");
      time = split[0] +  ":"  + split[1];
    } else {
      time = "";
    }

    return(
      <div>
        <Input iconPosition='left' placeholder='time'>
          <input
            onClick={ this.visiHandler }
            value={ time }
            placeholder={ "Select Time" }
          />
          <Icon name='clock outline' />
        </Input>
        {
          this.props.visible &&
          <TimeKeeper
            time={ time === "" || time === null ? null:time }
            onChange={ this.onChangeTimeHandler }
            onDoneClick={ this.timeDoneHandler }
            hour24Mode
            switchToMinuteOnHourSelect
          />
        }
      </div>
    );
  }

}

export default TimePicker;
